import { Crisp } from 'crisp-sdk-web';
import { useEffect } from 'react';

const Chat = () => {
  useEffect(() => {
    const crispWebsiteId = process.env.REACT_APP_CRISP_WEBSITE_ID;

    if (!crispWebsiteId) {
      throw new Error('REACT_APP_CRISP_WEBSITE_ID environment variable is not set.');
    } else {
      Crisp.configure(crispWebsiteId);
    }
  }, []);

  return null;
};

export default Chat;
